import { Route, Routes } from 'react-router'
import InhouseRequest from '../pages/inhouseRequest.tsx'
import NotFound from '../pages/NotFound.tsx'
import { useEffect } from 'react'
import { createSpinner } from '@syncfusion/ej2-react-popups'


const Pages = () => {
  useEffect(() => {
    const html = document.getElementById('mainTarget')
    if (html instanceof HTMLElement) {
      createSpinner({
        target: html,
      })
    }
  }, [])

  return (

    <Routes>
      {/* Wurzelroute */}
      <Route path="/" element={<InhouseRequest />} />
      <Route path="/:topicId" element={<InhouseRequest />} />
      {/* Fallback-Route */}
      <Route path="*" element={<NotFound />} />
    </Routes>


  )
}

export default Pages
